import React from "react";
import SignIn from "../components/signin";
import LanguageSelector from "../components/language/LanguageSelector";

function Login() {
  return (
    <div className="login-container">
      <div className="header-language-selector">
        <LanguageSelector />
      </div>
      <SignIn />
    </div>
  );
}

export default Login;
